const TASK_AWAITING_MESSAGES_CONFIG = {
  CURATION_PENDING: {
    title: 'Curating...',
    description: 'Please wait until the curation finishes',
    isCloseable: false,
  },
  DUPLICATE_PENDING: {
    title: 'Duplicating...',
    description: 'Please wait until the duplication finishes',
    isCloseable: false,
  },
  IMPORT_PENDING: {
    title: 'Importing...',
    description: `The import is in progress.
       You will receive a notification when the import is finished if you are on another page.`,
    isCloseable: false,
  },
  HAS_TIMEOUT_ERROR: {
    title: 'Unavailable',
    description: `The task is unavailable due to a timeout error. The task will be retried automatically in a few hours. If the error persists, please bucket and report the issue.`,
    isCloseable: true,
  },
  HAS_UNCAUGHT_MENU_CURATOR_ERROR: {
    title: 'Unavailable',
    description: `The task is unavailable due to an uncaught Menu Curator error. Please bucket and report the issue.`,
    isCloseable: true,
  },
  HAS_UNCAUGHT_AI_ERROR: {
    title: 'Unavailable',
    description: `The task is unavailable due to an uncaught AI error. Please bucket and report the issue.`,
    isCloseable: true,
  },
  EXCLUDED: {
    title: 'Excluded',
    description: 'The task has been excluded by autoeat',
    isCloseable: true,
  },
  AWAITING_SCRAPING_REVIEW: {
    title: 'Unavailable',
    description: 'Unavailable the task is under Scraping Review',
    isCloseable: true,
  },
  SCRAPING_REVIEW_IN_PROGRESS: {
    title: 'Unavailable',
    description: 'Unavailable the task is under Scraping Review',
    isCloseable: true,
  },
  AWAITING_AUTOEAT_UPDATES: {
    title: 'Unavailable',
    description: 'Unavailable the task is under AutoEat Review',
    isCloseable: true,
  },
}

export default TASK_AWAITING_MESSAGES_CONFIG
